import * as React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import Select from 'react-select';

const selectSmStyles = {
    control: (base) => ({ ...base, minHeight: '31px', height: '31px' }),
    valueContainer: (base) => ({ ...base, height: '31px', padding: '0 6px' }),
    indicatorsContainer: (base) => ({ ...base, height: '31px' }),
    dropdownIndicator: (base) => ({ ...base, padding: '4px' }),
    clearIndicator: (base) => ({ ...base, padding: '4px' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
}

class EmployeeMasterSearchComponent extends React.Component<any, { valueSelectRole: string }> {

    constructor(props: any) {
        super(props)
        this.state = {
            valueSelectRole: ""
        }
    }

    handleValueSelectAdd = (newValue: any, actionMeta: any) => {
        this.props.handleSelectSearch(newValue)
    };

    handleValueroleAccessAdd = (newValue: any, actionMeta: any) => {
        this.setState({ valueSelectRole: newValue ? newValue.value : "" })
    };

    handleSearchValue = () => {
        var userName = document.getElementById('userName') as HTMLInputElement;
        this.props.handleSearchValue(userName.value, this.state.valueSelectRole)
    };

    render() {
        return (
            <div>
                <div className='trapezoid trapezoid-purple' style={{ width: '200px', display: 'inline-block' }}>
                    <span>Search menu</span>
                </div>
                <div className="mat-box shadow p-3 mb-5 bg-white rounded">
                    <Row>
                        <Col sm={4}>
                            <Form.Group className="mb-3" controlId="userName">
                                <Form.Label>User Name :</Form.Label>
                                <Form.Control type="text" size="sm" placeholder="Enter User Name" />
                            </Form.Group>
                        </Col>
                        <Col sm={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>บริษัท :</Form.Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={selectSmStyles}
                                    placeholder="เลือก บริษัท"
                                    options={this.props.valueSelect}
                                    onChange={this.handleValueSelectAdd}
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={4}>
                            <Form.Group className="mb-3" controlId="roleAccess">
                                <Form.Label>Role Access :</Form.Label>
                                <Select
                                    menuPortalTarget={document.body}
                                    styles={selectSmStyles}
                                    placeholder="เลือก Role Access"
                                    options={this.props.valueSelectRole}
                                    onChange={this.handleValueroleAccessAdd}
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        <Col lg={{ span: 2, offset: 10 }}>
                            <div className="mb-3 w-100 mt-4 d-flex justify-content-end">
                                <Button variant="info" size="sm" className="mx-1 btn btn-block" onClick={this.handleSearchValue}>
                                    <FaSearch /> Search
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default EmployeeMasterSearchComponent
